import React from 'react';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import ExpressWifiNavBar from '../../../../layouts/expresswifi/ExpressWifiNavBar';
import ExpressWifiAmbassadorsBody from './ExpressWifiActiveAmbassadorsBody';

const ExpressWifiAmbassadors = () => {
  const { profile } = useUser();
  const { firstName } = profile;
  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <ExpressWifiNavBar currentPage="List of Active Ambassadors" position={firstName} />
        <ExpressWifiAmbassadorsBody />
      </main>
    </div>
  );
};

export default ExpressWifiAmbassadors;
